var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventDetailsActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12773",
    "data-name": "Group 12773",
    transform: "translate(1440)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12772",
    "data-name": "Group 12772",
    transform: "translate(-1437.115 2.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12757",
    "data-name": "Group 12757",
    transform: "translate(0.577 8.654)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3788",
    "data-name": "Rectangle 3788",
    width: 24,
    height: 1,
    transform: "translate(-0.461 0.461)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12758",
    "data-name": "Group 12758",
    transform: "translate(7.5 2.885)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3789",
    "data-name": "Rectangle 3789",
    width: 10,
    height: 1,
    transform: "translate(-0.385 0.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12759",
    "data-name": "Group 12759",
    transform: "translate(0 2.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11310",
    "data-name": "Path 11310",
    d: "M-1412.5,31.346h-20.769A1.733,1.733,0,0,1-1435,29.615V11.731A1.733,1.733,0,0,1-1433.269,10h2.308v1.154h-2.308a.578.578,0,0,0-.577.577V29.615a.578.578,0,0,0,.577.577h20.769a.578.578,0,0,0,.577-.577V11.731a.578.578,0,0,0-.577-.577h-2.308V10h2.308a1.733,1.733,0,0,1,1.731,1.731V29.615A1.733,1.733,0,0,1-1412.5,31.346Z",
    transform: "translate(1435 -10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12760",
    "data-name": "Group 12760",
    transform: "translate(16.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11311",
    "data-name": "Path 11311",
    d: "M-1402.385,10.769H-1407V6.154A1.155,1.155,0,0,1-1405.846,5h2.308a1.155,1.155,0,0,1,1.154,1.154Zm-3.462-1.154h2.308V6.154h-2.308Z",
    transform: "translate(1407 -5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12761",
    "data-name": "Group 12761",
    transform: "translate(3.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11312",
    "data-name": "Path 11312",
    d: "M-1424.385,10.769H-1429V6.154A1.155,1.155,0,0,1-1427.846,5h2.308a1.155,1.155,0,0,1,1.154,1.154Zm-3.462-1.154h2.308V6.154h-2.308Z",
    transform: "translate(1429 -5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12762",
    "data-name": "Group 12762",
    transform: "translate(8.654 12.692)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3790",
    "data-name": "Rectangle 3790",
    width: 2,
    height: 1,
    transform: "translate(0.461 0.423)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12763",
    "data-name": "Group 12763",
    transform: "translate(13.269 12.692)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3791",
    "data-name": "Rectangle 3791",
    width: 2,
    height: 1,
    transform: "translate(-0.154 0.423)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12764",
    "data-name": "Group 12764",
    transform: "translate(17.885 12.692)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3792",
    "data-name": "Rectangle 3792",
    width: 2,
    height: 1,
    transform: "translate(0.23 0.423)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12765",
    "data-name": "Group 12765",
    transform: "translate(4.038 16.077)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3793",
    "data-name": "Rectangle 3793",
    width: 2,
    height: 1,
    transform: "translate(0.076 -0.462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12766",
    "data-name": "Group 12766",
    transform: "translate(8.654 16.077)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3794",
    "data-name": "Rectangle 3794",
    width: 2,
    height: 1,
    transform: "translate(0.461 -0.462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12767",
    "data-name": "Group 12767",
    transform: "translate(13.271 16.077)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3795",
    "data-name": "Rectangle 3795",
    width: 2,
    height: 1,
    transform: "translate(-0.154 -0.462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12768",
    "data-name": "Group 12768",
    transform: "translate(17.885 16.077)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3796",
    "data-name": "Rectangle 3796",
    width: 2,
    height: 1,
    transform: "translate(0.23 -0.462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12769",
    "data-name": "Group 12769",
    transform: "translate(4.038 18.462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3797",
    "data-name": "Rectangle 3797",
    width: 2,
    height: 1,
    transform: "translate(0.076 -0.346)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12770",
    "data-name": "Group 12770",
    transform: "translate(8.654 18.462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3798",
    "data-name": "Rectangle 3798",
    width: 2,
    height: 1,
    transform: "translate(0.461 -0.346)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12771",
    "data-name": "Group 12771",
    transform: "translate(13.269 18.462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3799",
    "data-name": "Rectangle 3799",
    width: 2,
    height: 1,
    transform: "translate(-0.154 -0.346)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3800",
    "data-name": "Rectangle 3800",
    width: 30,
    height: 30,
    transform: "translate(-1440)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDetailsActive);
export default __webpack_public_path__ + "static/media/event_details_active.6f05a04eb8adc194e521597851b7fa08.svg";
export { ForwardRef as ReactComponent };